// auth/token.ts
import { LOCAL_STORAGE_KEYS } from "../../utils/localStorageKeys";

let accessToken: string | null = localStorage.getItem(
  LOCAL_STORAGE_KEYS.ACCESS_TOKEN
);
let refreshPromise: Promise<string | null> | null = null;

export const tokenStore = {
  get: () => accessToken,
  set: (t: string | null) => {
    accessToken = t;
    if (t) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, t);
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    }
  },
  has: () => Boolean(accessToken),
  beginRefresh(fn: () => Promise<string | null>) {
    if (!refreshPromise) {
      refreshPromise = fn().finally(() => (refreshPromise = null));
    }
    return refreshPromise;
  },
};

export const authSession = {
  setAccessToken: (t: string | null) => tokenStore.set(t),
  clear: () => tokenStore.set(null),
};
